import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Button, Text } from 'src/Components'
import { IconImageInverted } from 'src/Components/shared/Icon'
import ListingActionBar from 'src/Components/ListingDetails/ListingActionBar'
import { OVERLAY_HELPERS } from 'src/constants/navigation'
import history from 'src/history'
import MainPanel from './MainPanel'
import Sidebar from './Sidebar'
import Section from '../Section'
import StatusHeader from '../StatusHeader'
import PropertyStats from '../PropertyStats'
import AddressSection from '../AddressSection'
import NmlsInfo from '../NmlsInfo'
import AgentCard from '../AgentCard'
import Description from '../Description'
import ThingsToNote from '../ThingsToNote'
import LocationMap from '../LocationMap'
import HomeDetails from '../HomeDetails'
import SimilarHomes from '../SimilarHomes'
import ListingsBot from '../ListingsBot'

import styles from './DesktopListingDetails.module.scss'
import { ChromeExtensionPromptCard } from '../ChromeExtensionPromptCard/Desktop/ChromeExtensionPromptCard'

const propTypes = {
  listing: PropTypes.shape({
    imageCoverUrl: PropTypes.string,
    thumbnailImageFileNames: PropTypes.arrayOf(PropTypes.string),
  }),
  similarListings: PropTypes.arrayOf(PropTypes.object),
}

const DesktopListingDetails = ({ listing, similarListings }) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    })
  }, [])

  const handleOnClick = () => {
    history.push(OVERLAY_HELPERS.listingDetailsPhotos.buildPath())
  }

  return (
    <div>
      <div className={styles.imageContainer}>
        <ListingActionBar showTourButton listing={listing} opacity={0} />
        {/* link should open slideshow modal */}
        <Button onClick={handleOnClick}>
          <img
            alt='property'
            src={listing.imageCoverUrl}
            className={styles.heroImage}
          />
        </Button>
      </div>

      <div className={styles.body}>
        <div className={styles.splitPaneContainer}>
          <MainPanel>
            <NmlsInfo listing={listing} />
            <div className={styles.basicHomeInfo}>
              <StatusHeader listing={listing} />
              <AddressSection listing={listing} />
            </div>

            <Description listing={listing} className={styles.section} />
            <ThingsToNote listing={listing} className={styles.section} />
            <LocationMap listing={listing} className={styles.section} />
            <HomeDetails listing={listing} className={styles.section} />
          </MainPanel>

          <Sidebar>
            <Button
              iconStart={IconImageInverted}
              secondary
              fullWidth
              className={styles.viewGalleryButton}
              onClick={handleOnClick}
            >
              <Text element='span' weight='semibold' size='s' variant='white'>
                <FormattedMessage
                  id='HomeSearch.listingDetails.photos.viewAll'
                  defaultMessage='View {photoCount} photos'
                  values={{
                    photoCount: listing.thumbnailImageFileNames?.length,
                  }}
                />
              </Text>
            </Button>

            <Section className={styles.section}>
              <Section.Body>
                <PropertyStats listing={listing} />
                <Section.Divider />
                <ListingsBot listing={listing} />
                <Section.Divider />
                {/* Add the little teeny tiny footer here! */}
              </Section.Body>
            </Section>

            <AgentCard className={styles.section} />
          </Sidebar>
        </div>

        {similarListings.length > 0 && (
          <SimilarHomes
            listings={similarListings}
            className={styles.section}
            isSlim
          />
        )}

        <ChromeExtensionPromptCard className={styles.section} />
      </div>
    </div>
  )
}

DesktopListingDetails.propTypes = propTypes

export default DesktopListingDetails
